import { View } from './view'

export const ComfortTerms = View
